module.exports = __webpack_public_path__ + "static/media/Discovery-Experience.fbaea128.svg";